import { useQuery } from '@tanstack/react-query';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { getUsers, GetUsersResponse } from 'src/api/getUsers/getUsers';
import { IUser } from 'src/types';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

const getAllUsers = async (
  after?: string,
  accumulated: IUser[] = [],
): Promise<GetUsersResponse> => {
  const { data, paging } = await getUsers(after);
  const users = [...accumulated, ...data];
  return paging?.after ? getAllUsers(paging.after, users) : { data: users };
};

export const useGetUsers = (enabled = true) => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();
  return useQuery({
    queryKey: [QueryKeys.USERS, 'all'],
    queryFn: () => getAllUsers(),
    enabled,
    onError: (e: Error) => {
      showSnackbar({
        message: e.message,
        status: SnackbarStatus.ERROR,
      });
      captureException(e);
    },
  });
};
